import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
  Description,
  Status,
  Name,
  NumberOfYear_,
  numberOfYear,
  multiYear,
  MULTIYEAR,
  FinanceBudgetCategories,
} from "../../../../../Constant";

import { toast } from "react-toastify";
import useAuth from "../../../../../Hooks/useAuth";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import { financesBudgetCategoriesApi } from "../../../../../api";

export default function useFinanceBudgetCategoriesForm() {
  const axiosPrivate = useAxiosPrivate();
  const formTitle = FinanceBudgetCategories;
  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: Name,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "1",
      colSize: 6,
    },
    {
      id: multiYear,
      name: multiYear,
      label: MULTIYEAR,
      type: "switch",
      value: "1",
      colSize: 6,
    },
    {
      id: NumberOfYear_,
      name: numberOfYear,
      type: "text",
      label: "No. Of Year",
      value: "",
      required: true,
      colSize: 6,
    },
  ]);

  // ?? Call on every dependent change
  async function updateFields() {
    const updatedFields = [...formFields];
    setFormFields(updatedFields);
  }

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    updateFields();
  }, []);

  const { layoutURL } = useContext(CustomizerContext);
  const backBtn = `${process.env.PUBLIC_URL}/finance/budgets/categories/${layoutURL}`;

  const onSubmit = async (data: any) => {
    data.organisation_id = userOrganisationId;
    // console.log(data);
    await axiosPrivate
      .post(financesBudgetCategoriesApi, data)
      .then((_res) => {
        toast.success(`${_res.data.data.name} Created Successfully.`);
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          toast.error("Validation Errors");
        } else if (err.response && err.response.status === 400) {
          toast.error(err.response.data.detail);
        } else {
          toast.error("Whoops! Something went wrong");
        }
        throw err;
        //toast.error(err.response.message || "Whoops! Something went wrong");
      });
  };

  return { formTitle, formFields, backBtn, onSubmit };
}
